<template>
  <div>
    <loader :loading="loading"/>
    <page-title :title="$t('dashboard.label')"/>

    <panel>
      <div class="l-row">
        <div class="l-col-3@md l-col-offset-9@md">
          <el-date-picker
            v-model="options.date"
            type="daterange"
            format="dd/MM/yyyy"
            start-placeholder="Data Inicial"
            end-placeholder="Data Final"
            @change="onChange"
            class="u-floatRight">
          </el-date-picker>
        </div>
      </div>
    </panel>

    <div class="l-row">
      <div class="l-col-3@md">
        <box-info :label="$t('orders.label')" :value="totalOrders" fontSize="30px" :loading="ordersByStatusReportLoading"/>
      </div>
      <div class="l-col-3@md">
        <box-info :label="$t('pending.label')" icon="icon-clock" :value="totalOrdersPending" fontSize="30px" color="u-color-warning" :loading="ordersByStatusReportLoading"/>
      </div>
      <div class="l-col-3@md">
        <box-info :label="$t('approved.label')" icon="icon-checkmark" :value="totalOrdersApproved" fontSize="30px" color="u-color-success" :loading="ordersByStatusReportLoading"/>
      </div>
      <div class="l-col-3@md">
        <box-info :label="$t('canceled.label')" icon="icon-cross" :value="totalOrdersCanceled" fontSize="30px" color="u-color-danger" :loading="ordersByStatusReportLoading"/>
      </div>
    </div>

    <div class="l-row">
      <div class="l-col-12@md">
        <line-chart identifier="myChart" v-if="ordersByMarketplaceAndDateChart" :data="ordersByMarketplaceAndDateChart" :loading="ordersByMarketplaceAndDateChartLoading"/>
      </div>
    </div>

    <div class="l-row">
      <div class="l-col-4@md">
        <panel title="Faturado">
          <loader :loading="ordersExpeditionStepsReportLoading"/>
          <div slot="header-right">
            <button @click="redirectToOrderByInvoiceStatus" v-if="percentInvoice != 100" class="btn hint hint--left" data-label="Verificar pendências">
              <i class="icon-warning2"></i>
            </button>
          </div>
          <span class="c-count__content count-info">
            {{ currentInvoice }}
          </span>
          <progress class="progress progress--sm" :value="percentInvoice" max="100"></progress>
          <span class="c-count__label count-label">{{ percentInvoice }}% dos pedidos aprovados estão faturados</span>
        </panel>
      </div>
      <div class="l-col-4@md">
        <panel title="Enviado">
          <loader :loading="ordersExpeditionStepsReportLoading"/>
          <div slot="header-right">
            <button @click="redirectToOrderByShippingStatus" v-if="percentShipping != 100" class="btn hint hint--left" data-label="Verificar pendências">
              <i class="icon-warning2"></i>
            </button>
          </div>
          <span class="c-count__content count-info">
            {{ currentShipping }}
          </span>
          <progress class="progress progress--info progress--sm" :value="percentShipping" max="100"></progress>
          <span class="c-count__label count-label">{{ percentShipping }}% dos pedidos faturados estão enviados</span>
        </panel>
      </div>
      <div class="l-col-4@md">
        <panel title="Entregue">
          <loader :loading="ordersExpeditionStepsReportLoading"/>
          <div slot="header-right">
            <button @click="redirectToOrderByDeliveryStatus" v-if="percentDelivery != 100" class="btn hint hint--left" data-label="Verificar pendências">
              <i class="icon-warning2"></i>
            </button>
          </div>
          <span class="c-count__content count-info">
            {{ currentDelivery }}
          </span>
          <progress class="progress progress--warning progress--sm" :value="percentDelivery" max="100"></progress>
          <span class="c-count__label count-label">{{ percentDelivery }}% dos pedidos enviados estão entregues</span>
        </panel>
      </div>
    </div>

    <div class="l-row vertical-flex">
      <div class="l-col-8@md">
        <panel title="Últimos pedidos">
          <loader :loading="lastOrdersLoading"/>
          <div slot="header-right">
            <router-link to="orders" class="c-menu__link">Ver todos</router-link>
          </div>

          <table class="table table--responsive" v-if="lastOrders.length">
            <thead>
              <tr>
                <th>{{ $t('id.label') }}</th>
                <th>{{ $t('total.label') }}</th>
                <th>{{ $t('status.label') }}</th>
                <th class="u-textRight">{{ $t('date.label') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="lastOrder in lastOrders">
                <td :data-label="$t('id.label')">
                  <router-link :to="{ name: 'order', params: { identifier: lastOrder.marketplace.identifier, code: lastOrder.marketplace.code } }" class="hint hint--right" data-label="Clique aqui para acessar">
                    #{{ lastOrder.marketplace.code }}
                  </router-link>
                </td>
                <td :data-label="$t('total.label')">{{ lastOrder.payment.total | currency }}</td>
                <td :data-label="$t('status.label')">
                  <span slot="header-right" class="badge" :class="lastOrder.status">{{ $t(lastOrder.status).label }}</span>
                </td>
                <td :data-label="$t('date.label')" class="u-textRight">
                  {{ lastOrder.created | moment('DD/MM/YYYY HH:mm') }}
                </td>
              </tr>
            </tbody>
          </table>

          <div class="u-textCenter teste" v-if="!lastOrders.length">
            Nenhum pedido encontrado.
          </div>
        </panel>
      </div>

      <div class="l-col-4@md">
        <div class="l-row">
          <div class="l-col-12@md">
            <panel title="Faturamento">
              <loader :loading="ordersIncomingReportLoading"/>
              <div class="l-level">
                <div class="l-level__item c-count">
                  <div class="c-count__content">
                    {{ ordersIncoming.current.total | currency }}
                  </div>

                  <span class="percent-incoming">
                    <i class="icon percent-icon" v-bind:class="arrowIncomingTotal"></i>
                    {{ ordersIncoming.current.percentTotal }}%
                  </span>
                </div>
              </div>
            </panel>
          </div>
          <div class="l-col-12@md">
            <panel title="Custo de transporte">
              <loader :loading="ordersIncomingReportLoading"/>
              <div class="l-level">
                <div class="l-level__item c-count">
                  <div class="c-count__content">
                    {{ ordersIncoming.current.shipping | currency }}
                  </div>

                  <span class="percent-incoming">
                    <i class="icon percent-icon" v-bind:class="arrowIncomingShipping"></i>
                    {{ ordersIncoming.current.percentShipping }}%
                  </span>
                </div>
              </div>
            </panel>
          </div>
        </div>
      </div>
    </div>

    <div class="l-row vertical-flex">
      <div class="l-col-4@md">
        <panel title="Produtos">
          <pie-chart identifier="productsByStatuses" v-if="quantityProductsByStatus && quantityProductsByStatus.labels.length" :data="quantityProductsByStatus" :loading="quantityProductsByStatusLoading"/>
          <div class="u-textCenter teste" v-else>
            Nenhuma informação de produto foi atualizada no filtro de data utilizado.
          </div>
        </panel>
      </div>

      <div class="l-col-4@md">
        <panel title="Preços">
          <pie-chart identifier="pricesByStatuses" v-if="quantityPricesByStatus && quantityPricesByStatus.labels.length" :data="quantityPricesByStatus" :loading="quantityPricesByStatusLoading"/>
          <div class="u-textCenter teste" v-else>
            Nenhum preço foi atualizado no filtro de data utilizado.
          </div>
        </panel>
      </div>

      <div class="l-col-4@md">
        <panel title="Estoques">
          <pie-chart identifier="stocksByStatuses" v-if="quantityStocksByStatus && quantityStocksByStatus.labels.length" :data="quantityStocksByStatus" :loading="quantityStocksByStatusLoading"/>
          <div class="u-textCenter teste" v-else>
            Nenhum estoque foi atualizado no filtro de data utilizado.
          </div>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import PageTitle from '@/components/template/PageTitle'
  import BoxInfo from '@/components/template/BoxInfo'
  import Api from '@/api'
  import LineChart from '@/components/template/LineChart'
  import PieChart from '@/components/template/PieChart'
  import Panel from '@/components/template/Panel'
  import { merge } from 'lodash'
  import Loader from '@/components/template/Loader'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      totalOrders: 0,
      totalOrdersPending: 0,
      totalOrdersApproved: 0,
      totalOrdersCanceled: 0,
      ordersByMarketplaceAndDateChart: null,
      currentInvoice: 0,
      percentInvoice: 0,
      currentShipping: 0,
      percentShipping: 0,
      currentDelivery: 0,
      percentDelivery: 0,
      ordersIncoming: {
        previous: {
          shipping: 0,
          total: 0,
          percentShipping: 0,
          percentTotal: 0
        },
        current: {
          shipping: 0,
          total: 0,
          percentShipping: 0,
          percentTotal: 0
        }
      },
      lastOrders: [],
      quantityProductsByStatus: null,
      quantityStocksByStatus: null,
      quantityPricesByStatus: null,
      options: {
        date: []
      },
      loading: false,
      ordersByStatusReportLoading: false,
      ordersByMarketplaceAndDateChartLoading: false,
      ordersExpeditionStepsReportLoading: false,
      ordersIncomingReportLoading: false,
      lastOrdersLoading: false,
      quantityProductsByStatusLoading: false,
      quantityStocksByStatusLoading: false,
      quantityPricesByStatusLoading: false
    }),
    mounted () {
      const actualDate = new Date()
      const oldDate = new Date()
      oldDate.setDate(actualDate.getDate() - 30)
      this.options.date.push(oldDate, actualDate)

      this.onChange()
    },
    methods: {
      ...mapActions('orders', [
        'fillFilter'
      ]),
      onChange () {
        this.loading = true

        this.getOrdersByStatus()
        this.getOrdersByMarketplaceAndDate()
        this.getExpeditionSteps()
        this.getLastOrders()
        this.getOrdersIncoming()
        this.getQuantityProductsByStatus()
        this.getQuantityPricesByStatus()
        this.getQuantityStocksByStatus()

        this.loading = false
      },
      getOrdersByStatus () {
        this.ordersByStatusReportLoading = true
        Api.ordersByStatusReport(this.options)
          .then(res => {
            const ordersByStatus = res
            this.totalOrders = ordersByStatus.total
            this.totalOrdersPending = ordersByStatus.pending
            this.totalOrdersApproved = ordersByStatus.approved
            this.totalOrdersCanceled = ordersByStatus.canceled
          })
          .catch(() => notifier.error('Erro ao carregar os status dos pedidos.', 'Erro'))
          .finally(() => {
            this.ordersByStatusReportLoading = false
          })
      },
      getOrdersByMarketplaceAndDate () {
        this.ordersByMarketplaceAndDateChartLoading = true
        Api.ordersByMarketplaceAndDateReport(this.options)
          .then(res => {
            const ordersByMarketplaceAndDate = res
            this.ordersByMarketplaceAndDateChart = null
            this.makeChartData(ordersByMarketplaceAndDate)
              .then(res => {
                this.ordersByMarketplaceAndDateChart = res
              })
          })
          .catch(() => notifier.error('Erro ao carregar os dados do gráfico.', 'Erro'))
          .finally(() => {
            this.ordersByMarketplaceAndDateChartLoading = false
          })
      },
      getExpeditionSteps () {
        this.ordersExpeditionStepsReportLoading = true
        Api.ordersExpeditionStepsReport(this.options)
          .then(res => {
            const expeditionSteps = res

            this.currentInvoice = expeditionSteps.invoice.current
            const invoiceTotal = expeditionSteps.invoice.current + expeditionSteps.invoice.available
            if (invoiceTotal) {
              this.percentInvoice = ((expeditionSteps.invoice.current * 100) / invoiceTotal).toFixed(2)
            }

            this.currentShipping = expeditionSteps.shipping.current
            const shippingTotal = expeditionSteps.shipping.current + expeditionSteps.shipping.available
            if (shippingTotal) {
              this.percentShipping = ((expeditionSteps.shipping.current * 100) / shippingTotal).toFixed(2)
            }

            this.currentDelivery = expeditionSteps.delivery.current
            const deliveryTotal = expeditionSteps.delivery.current + expeditionSteps.delivery.available
            if (deliveryTotal) {
              this.percentDelivery = ((expeditionSteps.delivery.current * 100) / deliveryTotal).toFixed(2)
            }
          })
          .catch(() => notifier.error('Erro ao carregar os dados de transporte dos pedidos.', 'Erro'))
          .finally(() => {
            this.ordersExpeditionStepsReportLoading = false
          })
      },
      getLastOrders () {
        const filter = {
          page: 1,
          limit: 5,
          sortField: 'createdAt',
          sortOrder: 'desc',
          marketplaceDate: this.options.date
        }

        this.lastOrdersLoading = true
        Api.getOrdersList(filter)
          .then(res => { this.lastOrders = res.items })
          .catch(() => notifier.error('Erro ao carregar os últimos pedidos.', 'Erro'))
          .finally(() => {
            this.lastOrdersLoading = false
          })
      },
      getOrdersIncoming () {
        this.ordersIncomingReportLoading = true
        Api.ordersIncomingReport(this.options)
          .then(res => {
            this.ordersIncoming = merge(this.ordersIncoming, res)
            if (this.ordersIncoming.previous.total > 0) {
              this.ordersIncoming.current.percentTotal = (((this.ordersIncoming.current.total - this.ordersIncoming.previous.total) * 100) / this.ordersIncoming.previous.total).toFixed(2)
            } else {
              this.ordersIncoming.current.percentTotal = 0
            }

            if (this.ordersIncoming.previous.shipping > 0) {
              this.ordersIncoming.current.percentShipping = (((this.ordersIncoming.current.shipping - this.ordersIncoming.previous.shipping) * 100) / this.ordersIncoming.previous.shipping).toFixed(2)
            } else {
              this.ordersIncoming.current.percentShipping = 0
            }
          })
          .catch(() => notifier.error('Erro ao carregar dados de faturamento e custo de transporte.', 'Erro'))
          .finally(() => {
            this.ordersIncomingReportLoading = false
          })
      },
      getQuantityProductsByStatus () {
        this.quantityProductsByStatusLoading = true
        Api.quantityProductsByStatusReport(this.options)
          .then(async res => {
            this.quantityProductsByStatus = await this.makePieChartData(res)
          })
          .catch(() => {
            if (this.$router.history.current.name === 'dashboard') {
              notifier.error('Erro ao carregar dados da quantidade de produtos em cada status.', 'Erro')
            }
          })
          .finally(() => { this.quantityProductsByStatusLoading = false })
      },
      getQuantityPricesByStatus () {
        this.quantityPricesByStatusLoading = true
        Api.quantityPricesByStatusReport(this.options)
          .then(async res => {
            this.quantityPricesByStatus = await this.makePieChartData(res)
          })
          .catch(() => {
            if (this.$router.history.current.name === 'dashboard') {
              notifier.error('Erro ao carregar dados da quantidade de preços em cada status.', 'Erro')
            }
          })
          .finally(() => { this.quantityPricesByStatusLoading = false })
      },
      getQuantityStocksByStatus () {
        this.quantityStocksByStatusLoading = true
        Api.quantityPricesByStatusReport(this.options)
          .then(async res => {
            this.quantityStocksByStatus = await this.makePieChartData(res)
          })
          .catch(() => {
            if (this.$router.history.current.name === 'dashboard') {
              notifier.error('Erro ao carregar dados da quantidade de estoques em cada status.', 'Erro')
            }
          })
          .finally(() => { this.quantityStocksByStatusLoading = false })
      },
      async makeChartData (data) {
        let labels = []
        let lines = []

        const translate = this.$t

        data.forEach(function (marketplace) {
          let values = []
          marketplace.data.forEach(function (value) {
            if (labels.indexOf(value.label) === -1) {
              labels.push(value.label)
            }
            values.push(value.value)
          })
          lines.push({
            identifier: translate(marketplace.identifier).label,
            values: values
          })
        })

        return {
          labels: labels,
          lines: lines
        }
      },
      async makePieChartData (data) {
        const labels = []
        const lines = []
        const colors = []

        const translate = this.$t

        Object.keys(data).forEach(function (status) {
          const values = []

          if (data[status]) {
            if (['notSynchronized', 'fail'].indexOf(status) !== -1) {
              colors.push('#d62728')
            }

            if (['synchronized', 'approved'].indexOf(status) !== -1) {
              colors.push('#4f8a10')
            }

            if (['cataloging'].indexOf(status) !== -1) {
              colors.push('#800080')
            }

            if (labels.indexOf(status) === -1) {
              labels.push(translate(`${status}.label`))
            }

            values.push(data[status])

            lines.push({
              identifier: translate(`${status}.label`),
              values: values
            })
          }
        })

        return {
          labels,
          lines,
          colors
        }
      },
      redirectToOrderByInvoiceStatus () {
        this.fillFilter({
          status: 'approved',
          invoiced: false
        })
        this.$router.push('/orders')
      },
      redirectToOrderByShippingStatus () {
        this.fillFilter({
          status: 'approved',
          invoiced: true,
          shipped: false
        })
        this.$router.push('/orders')
      },
      redirectToOrderByDeliveryStatus () {
        this.fillFilter({
          status: 'approved',
          shipped: true,
          delivered: false
        })
        this.$router.push('/orders')
      }
    },
    computed: {
      arrowIncomingTotal () {
        return {
          'u-color-success icon-arrow-up-right2': !!(this.ordersIncoming.current.percentTotal > 0),
          'u-color-danger icon-arrow-down-right2': !!(this.ordersIncoming.current.percentTotal < 0),
          'u-color-warning icon-minus': !!(this.ordersIncoming.current.percentTotal === 0)
        }
      },
      arrowIncomingShipping () {
        return {
          'u-color-danger icon-arrow-up-right2': !!(this.ordersIncoming.current.percentTotal > 0),
          'u-color-success icon-arrow-down-right2': !!(this.ordersIncoming.current.percentTotal < 0),
          'u-color-warning icon-minus': !!(this.ordersIncoming.current.percentTotal === 0)
        }
      }
    },
    components: {
      PageTitle,
      BoxInfo,
      LineChart,
      PieChart,
      Panel,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .count-info
    margin-bottom: 10px
    display: block

  .percent-incoming
    margin-top: 5px
    display: block

  .percent-icon
    margin-right: 5px

  .icon-warning2
    color: #6BE88D
</style>



// WEBPACK FOOTER //
// Base.vue?1fb33a88